import { render, staticRenderFns } from "./AffiliateWeeklyCommissionsBreakdown.vue?vue&type=template&id=33dea72a&"
import script from "./AffiliateWeeklyCommissionsBreakdown.vue?vue&type=script&lang=js&"
export * from "./AffiliateWeeklyCommissionsBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports